import { TFunction } from 'i18next';
import { z } from 'zod';

export const getSubjectSchema = (t: TFunction) =>
  z.object({
    description: z.string().trim().nonempty(t('common.validation.descriptionRequired')),
    visibleOnApp: z.boolean().optional(),
    addresses: z
      .array(
        z.object({
          addressId: z.string().nonempty(),
          email: z.string().optional(),
          description: z.string().optional(),
        }),
      )
      .optional(),
    scGroups: z
      .array(
        z.object({
          priority: z.number(),
          scGroup: z.string(),
        }),
      )
      .optional(),
  });
